import Favicon from '@assets/hairscalpFavicon.ico';
import { ReactComponent as Ban } from '@assets/icons/ban.svg';
import { ReactComponent as CalendarClock } from '@assets/icons/calendar-clock.svg';
import { ReactComponent as CalendarSolid } from '@assets/icons/calendar-solid.svg';
import { ReactComponent as Check } from '@assets/icons/check.svg';
import { ReactComponent as CircleDollar } from '@assets/icons/circle-dollar.svg';
import { ReactComponent as CircleExclamation } from '@assets/icons/circle-exclamation.svg';
import { ReactComponent as CogSolid } from '@assets/icons/cog-solid.svg';
import { ReactComponent as CreditCardFront } from '@assets/icons/credit-card-front.svg';
import { ReactComponent as Crown } from '@assets/icons/crown.svg';
import { ReactComponent as DefaultProviderAvatar } from '@assets/icons/default-provider-avatar.svg';
import { ReactComponent as Envelope } from '@assets/icons/envelope-solid.svg';
import { ReactComponent as ListRadio } from '@assets/icons/list-radio.svg';
import { ReactComponent as PainBrushSolid } from '@assets/icons/paint-brush-solid.svg';
import { ReactComponent as ReceiptSolid } from '@assets/icons/receipt-solid.svg';
import { ReactComponent as ShoppingBag } from '@assets/icons/shopping-bag.svg';
import { ReactComponent as Facebook } from '@assets/icons/square-facebook.svg';
import { ReactComponent as Instagram } from '@assets/icons/square-instagram.svg';
import { ReactComponent as Youtube } from '@assets/icons/youtube.svg';
// Login assets
import login_banner_desktop_1 from '@assets/images/login/hairscalp/login_banner_desktop_1.webp';
// import login_banner_desktop_2 from '@assets/images/login/hairscalp/login_banner_desktop_2.jpg';
// import login_banner_desktop_3 from '@assets/images/login/hairscalp/login_banner_desktop_3.jpg';
// import login_banner_mobile_1 from '@assets/images/login/hairscalp/mobile_banner_1.jpg';
// import login_banner_mobile_2 from '@assets/images/login/hairscalp/mobile_banner_2.jpg';
// import login_banner_mobile_3 from '@assets/images/login/hairscalp/mobile_banner_3.jpg';
// Logo assets
import Logo from '@assets/images/logo/hairscalp/hairscalpLogo.png';
import { ReactComponent as LogoIcon } from '@assets/images/logo/hairscalp/hairscalpLogo.svg';
import notFoundImage from '@assets/images/not-found.png';
// OLB assets
// import locationBanner from '@assets/images/olb/hairscalp/location-banner.jpg';
// import locationBannerMobile from '@assets/images/olb/hairscalp/location-banner-mobile.jpg';
import ModalOlbBanner from '@assets/images/olb/hairscalp/modalBannerDark.webp';
// Shop assets
import giftCards from '@assets/images/shop/hairscalp/gift-cards.webp';
import giftCardsMobile from '@assets/images/shop/hairscalp/gift-cards-mobile.webp';
import membershipShop from '@assets/images/shop/hairscalp/memberships.webp';
import membershipShopMobile from '@assets/images/shop/hairscalp/memberships-mobile.webp';
import productsShopMobile from '@assets/images/shop/hairscalp/mobile-products.webp';
import packagesBanner from '@assets/images/shop/hairscalp/packages.webp';
import ModalPackagesBanner from '@assets/images/shop/hairscalp/packages/modalBanner.webp';
import packagesBannerMobile from '@assets/images/shop/hairscalp/packages-mobile.webp';
import productsShop from '@assets/images/shop/hairscalp/productsShop.webp';
// import packagesShopMobile from '@assets/images/shop/hairscalp/packages-mobile.webp';
// Dashboard sidebar assets
import giftCardsImage from '@assets/images/sidebar/hairscalp/gift_cards_balance_bg.png';
import promo_banner_desktop_1 from '@assets/images/sidebar/hairscalp/promo_banner_desktop_1.webp';
import promo_banner_desktop_2 from '@assets/images/sidebar/hairscalp/promo_banner_desktop_2.webp';
import promo_banner_desktop_3 from '@assets/images/sidebar/hairscalp/promo_banner_desktop_3.webp';
// Variables
import { defaultProvider, ROUTES } from 'constant';

import {
  AccessStep,
  BookingSteps,
  MembershipShopSteps,
  ShoppingCartName
} from 'types';

// Theme
import colors from './colors';
import palette from './palette';

const allowGuestShop = false;
const termsAndConditionsUrl = 'https://www.hairscalp.com/privacy-policy/';

export const hairscalp = {
  name: 'hairscalp',
  logo: Logo,
  iconLogo: LogoIcon,
  isSquareIcon: false,
  logoLink: ROUTES.dashboard,
  isExternalLink: false,
  isAddToCalendarAvailable: false,
  isNotificationAvailable: true,
  api: {
    // url: 'https://stage-korvue.hairscalp.com/olb-api/',
    // liveUrl: 'https://korvue.hairscalp.com/olb-api/'
    url: 'https://demo-pos.korvuelabs.com/olb-api/',
    liveUrl: 'https://demo-pos.korvuelabs.com/olb-api/'
  },
  gtm_key: 'GTM-5PC3CNN',
  metadata: {
    favIcon: Favicon,
    title: 'The Hair & Scalp Specialists – Book Your Appointment Online',
    description:
      'Book your appointment online with Jeffrey Paul’s Hair & Scalp Specialists in Cleveland. We provide expert hair loss solutions, custom wigs & toppers, and trichology-based scalp treatments in a private, supportive setting'
  },
  copyrightLabel: 'The Hair & Scalp Specialists',
  common: {
    termsAndConditionsUrl
  },
  socialLinks: [
    {
      link: 'https://www.facebook.com/HairScalpSpecialists/',
      Icon: Facebook
    },
    {
      link: 'https://www.instagram.com/hairscalpspecialists/',
      Icon: Instagram
    },
    {
      link: 'https://www.youtube.com/channel/UCzOeLik88I-HwESgWHo6Y8w',
      Icon: Youtube
    }
  ],

  header: {
    shoppingCartType: ShoppingCartName.Cart,
    shopLink: ROUTES.shop,
    cartLink: ROUTES.shop
  },

  footerMenu: [
    // {
    //   label: 'Terms & Conditions',
    //   href: termsAndConditionsUrl,
    //   isExternal: true
    // },
    {
      label: 'Privacy Policy',
      href: 'https://www.hairscalp.com/privacy-policy/',
      isExternal: true
    },
    {
      label: 'Careers',
      href: 'https://www.hairscalp.com/nowhiring/',
      isExternal: true
    }
  ],
  notFound: {
    title: "We can't find the page you're looking for",
    description:
      "The page has vanished—or maybe it was never here. Either way, let's get you where you need to go.",
    navigationLabel: 'Would you like to...',
    bavigationButtons: [
      {
        label: 'BOOK AN APPOINTMENT',
        link: ROUTES.booking
      },
      {
        label: 'GO SHOPPING',
        link: ROUTES.shop
      },
      {
        label: 'VIEW YOUR PROFILE',
        link: ROUTES.profile
      },
      {
        label: 'VISIT OUR HOME PAGE',
        link: ROUTES.dashboard
      }
    ],
    image: notFoundImage
  },
  siteAlert: {
    areaIds: {
      // home: 10000,
      // login: 10009,
      // createAccount: 10008,
      // createPassword: 10007,
      // forgotPassword: 10006,
      // shop: 10005,
      // packagesShop: 10004,
      // giftCardsShop: 10003,
      // booking: 10002,
      // dashboard: 10001
    },
    desktop_banners: [
      login_banner_desktop_1
      // login_banner_desktop_2,
      // login_banner_desktop_3
    ],
    mobile_banners: [
      // login_banner_mobile_1
      // login_banner_mobile_2,
      // login_banner_mobile_3
    ]
  },
  locations: {
    isDropdownList: false
  },
  poweredByText: 'Designed and Powered by KORVUE',
  linkAuthor: 'https://korvue.com/',

  colors: {
    ...colors,
    palette
  },

  contacts: {
    phone: '4403338939',
    email: 'WeHelp@HairScalp.com'
  },

  login: {
    isPolicyAcceptRequired: false,
    desktop_banners: [
      login_banner_desktop_1
      // login_banner_desktop_2,
      // login_banner_desktop_3
    ],
    mobile_banners: [
      // login_banner_mobile_1
      // login_banner_mobile_2,
      // login_banner_mobile_3
    ],
    isPronounceAvailable: false,
    genderPlaceholder: 'Gender',
    genderValues: [
      { label: 'Male', value: 'M' },
      { label: 'Female', value: 'F' },
      { label: 'Prefer Not To Say', value: '' }
    ],
    registerTitle: 'New to The Hair & Scalp Specialists?',
    registerSubtitle:
      'Registering provides a fast, simple way to manage your account\n' +
      'online. Once registered and logged in, you can view your\n' +
      'scheduled appointments, appointment history, and available gift\n' +
      'cards and series packages in your account. You’ll also be able\n' +
      'to fill out forms before your visit and keep your communication\n' +
      'preferences up to date. If you’re a member, you’ll be able to see\n' +
      'when exclusive perks become available',
    createAccount: {
      title: 'Create Your Password',
      description:
        'Please create a password following the minimum requirements below'
    },
    loginToContinue: {
      bookingAppointments:
        'To finish your appointment booking please, sign in to your account or register',
      giftCardPurchase:
        'To finish your gift card purchase please, sign in to your account or register',
      packagePurchase:
        'To finish your package purchase please, sign in to your account or register',
      productPurchase:
        'To finish your product purchase please, sign in to your account or register',
      membershipPurchase:
        'To finish your membership purchase please, sign in to your account or register'
    },
    errors: {
      accountAlreadyExist:
        'This email is already associated with an existing account',
      noMatchMembership: 'That combination doesn’t exist. Please try again.',
      wrongCredential:
        "That username and password combination doesn't exist. Please try again."
    }
  },

  guestCheckout: {
    title: 'Guest Checkout',
    description: 'Enter your contact details below to continue'
  },

  existingAccount: {
    title: 'Looks Like You Have An Account!',
    description: 'Please enter your password below or click Forgot Password'
  },

  resetPassword: {
    restorePasswordStep: {
      title: 'Reset Password',
      description:
        "Don't worry, it happens to the best of us. We'll help you get through this. Please enter required data below."
    },
    contactStep: {
      title: 'We Found You!',
      titleNoData: 'We Found You, However…',
      description: 'Where can we send your verification code?',
      multipleAppearenceDescription:
        'You appear in our system multiple times. To ensure we activate the correct account, please contact us at your convenience.',
      descriptionEmptyContacts:
        'We do not have a phone number or email address on file to send a verification code. For assistance, please contact us at your convenience.',
      helperText: 'If you need help please contact us at'
    },
    successStep: {
      title: 'Code Sent!'
    },
    confirmCodeStep: {
      title: 'Code Sent!',
      description:
        'If you don\'t receive the code shortly, click "BACK" to try again or to send the code by another way'
    },
    changePasswordStep: {
      title: 'Update Password',
      description: 'please create a new password'
    },
    congratulationsStep: {
      title: 'All Set!',
      description:
        'To access your account, please sign in using your new password'
    },
    errors: {
      noMatchMembership: 'That combination doesn’t exist. Please try again.'
    }
  },

  dashboard: {
    sidebar: {
      promoBanners: [
        { img: promo_banner_desktop_1, url: '' },
        { img: promo_banner_desktop_2, url: '' },
        { img: promo_banner_desktop_3, url: '' }
      ],
      giftCard: giftCardsImage,
      availableGiftCardsText: 'Available gift cards',
      noGiftCardsText: 'You do not have any gift cards',
      isReferFriend: true,
      profileTabs: [
        {
          label: 'My Appointments',
          link: ROUTES.appointments
        },
        {
          label: 'My Gift Cards',
          link: ROUTES.giftCards
        }
      ],
      myAccountLinks: [
        {
          label: 'My Profile',
          link: ROUTES.profile
        },
        {
          label: 'My Addresses',
          link: ROUTES.addresses
        },
        {
          label: 'Payment Methods',
          link: ROUTES.creditCards
        },
        {
          label: 'My Preferences',
          link: ROUTES.preferences
        }
      ]
    },
    tabs: [
      {
        label: 'Dashboard',
        link: ROUTES.dashboard
      },
      {
        label: 'Appointments',
        link: ROUTES.appointments
      },
      {
        label: 'Forms',
        link: ROUTES.forms
      },
      {
        label: 'Services',
        link: ROUTES.services
      },
      {
        label: 'Packages',
        link: ROUTES.packages
      },
      {
        label: 'Products',
        link: ROUTES.products
      },
      {
        label: 'Purchases',
        link: ROUTES.orders
      }
    ],
    mobileTabs: [
      {
        label: 'My Memberships',
        link: ROUTES.memberships
      },
      {
        label: 'My Profile',
        link: ROUTES.profile
      },
      {
        label: 'My Addresses',
        link: ROUTES.addresses
      },
      {
        label: 'Payment Methods',
        link: ROUTES.creditCards
      },
      {
        label: 'My Preferences',
        link: ROUTES.preferences
      },
      {
        label: 'My Gift Cards',
        link: ROUTES.giftCards
      }
    ],
    profile: {
      genderPlaceholder: 'Gender',
      genderValues: [
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' },
        { value: 'prefer not to say', label: 'Prefer Not To say' }
      ]
    },
    upcomingAppointments: {
      title: 'Upcoming Appointments',
      emptyMessage: 'No Upcoming Appointments'
    },
    recentProducts: {
      isRecentProductsBlockDisplayed: true,
      title: 'Recent Products',
      emptyMessage: 'No Recent Products'
    }
  },

  myProducts: {
    title: 'Products',
    emptyRecentProductsMessage: 'NO RECENT PURCHASES',
    emptyFavoriteProductsMessage: 'No Favorite Products',
    emptyMessageBrowsePage: 'No Products Found'
  },

  myMemberships: {
    title: 'My Memberships',
    isAvailable: true,
    isAvailableJoin: true,
    joinLink: ROUTES.memberships,
    noMember: {
      titleRow1:
        'Unlock a world of benefits with our exclusive membership program',
      titleRow2: 'Enjoy premium perks',
      list: [
        {
          bold: 'Exclusive Discounts: ',
          regular: 'Save big on your favorite products and services'
        },
        {
          bold: 'Early Access: ',
          regular: 'Be the first to access new releases and special events'
        },
        {
          bold: 'Loyalty Rewards: ',
          regular: 'Earn points and rewards for every purchase'
        }
      ]
    },
    modal: {
      modalBanners: [ModalOlbBanner],
      phone: '4403338939',
      notProrateTitle: 'Next Billing',
      notProrateDesc:
        'Your membership will be activated in the next 12 hours for the remaining period according to your contract',
      prorateTitle: 'Contact us',
      prorateDesc: 'To unfreeze your membership please contact us at',
      helperText: 'If you need help please contact us at'
    }
  },

  myAppointments: {
    title: 'Appointments',
    contactPhone: '4403338939',
    upcomingAppointments: {
      title: 'Upcoming Appointment Details',
      emptyMessage: 'No Upcoming Appointments'
    },
    recentAppointments: {
      title: 'Recent Appointment Details',
      emptyMessage: 'No Recent Appointments'
    }
  },

  myPackages: {
    title: 'Packages',
    emptyMessage: 'No Items'
  },

  myAddressBook: {
    title: 'Address Book',
    newAddressTitle: 'New Address',
    updateAddressTitle: 'Update Address',
    emptyMessage: 'No Addresses'
  },

  myGiftCards: {
    isAvailable: true,
    title: 'Gift Cards'
  },

  myForms: {
    requiredForms: {
      emptyMessage: 'No Required Forms'
    },
    signedForms: {
      emptyMessage: 'No Signed Forms'
    }
  },

  myPurchases: {
    title: 'Purchases',
    emptyMessage: 'No Items'
  },

  myCreditCards: {
    displayPurchases: false,

    statusIcons: {
      premium: Crown,
      allow: Check,
      forbid: Ban
    },
    cardContent: {
      cardList: {
        title: 'Payment Methods'
      },
      newCardForm: {
        title: 'Add New Credit Card',
        subtitle:
          'Securely add your credit card. Your card can be updated anytime.'
      },
      updateCardForm: {
        title: 'Update Credit Card',
        subtitle: 'Update credit card details'
      }
    },
    emptyMessage: 'No credit cards'
  },

  myServices: {
    title: 'Services',
    subtitle: 'View your recent services',
    emptyMessage: 'No services',
    emptyRecentHistoryMessage: 'No Recent History',
    emptyAlsoOfferedMessage: 'No Locations'
  },

  myPreferences: {
    title: 'Preferences',
    description:
      'The option icons below can be toggled on and off. More than one icon can be toggled on for each applicable \n' +
      'option. If all are toggled off, then the option is disabled.',
    items: {
      appointmentsConfirmation: {
        label: 'Appointment Confirmations',
        description:
          'We will confirm your appointment to ensure it still fits within your schedule',
        icon: CalendarSolid
      },
      sameDayReminder: {
        label: 'Same Day Reminder',
        description:
          'To accommodate your busy schedule, we can send you a reminder the morning of your appointment',
        icon: CalendarSolid
      },
      advancedSearch: {
        label: 'Advanced Search',
        description:
          'When booking using the Advanced Search feature here or in the app, the following can save you time',
        icon: CalendarSolid
      },
      receipts: {
        label: 'Receipts',
        description:
          'To personalize your checkout experience, we offer all receipt options. To protect our environment,\n' +
          'we kindly prefer that you select a paperless option.',
        icon: ReceiptSolid
      },
      preferredPhone: {
        label: 'Preferred Phone',
        description:
          'If a reason arises where we need to call you, we will first attempt your preferred phone',
        icon: CogSolid
      },
      marketing: {
        label: 'Marketing ',
        description:
          'We’ll send you the latest news about promotions, events, and more',
        icon: CogSolid
      }
    }
  },

  shop: {
    isCommerceAvailable: true,
    isMembershipAvailable: true,
    isPackagesAvailable: true,
    isGiftCardsAvailable: true,
    isProductsAvailable: true,
    isAllowGuestCheckout: allowGuestShop,
    title: 'Select the Category You’d Like to Shop!',
    description:
      'Experience The Hair & Scalp Specialists excellence through our treatments, products, and memberships.\nYou can also gift the experience to a loved one!',
    paddings: { base: 0, md: 0, lg: 0 },
    subtitle: 'Discounts will apply in cart',
    isImageClick: true,
    isShopBtnVisible: false,
    mobileItemScale: 1.75,
    isDefaultItems: false,
    defaultItems: [],
    shopItems: [
      {
        pkg_label_id: -1,
        image: {
          desktop: packagesBanner,
          mobile: packagesBannerMobile
        },
        title: '',
        description: '',
        linkUrl: ROUTES.packagesShop
      },
      {
        pkg_label_id: -2,
        image: { desktop: giftCards, mobile: giftCardsMobile },
        title: '',
        description: '',
        linkUrl: ROUTES.giftCardsShop
      },
      {
        pkg_label_id: -3,
        image: { desktop: membershipShop, mobile: membershipShopMobile },
        title: '',
        description: '',
        linkUrl: ROUTES.membershipShop
      },
      {
        pkg_label_id: -4,
        image: {
          desktop: productsShop,
          mobile: productsShopMobile
        },
        title: '',
        description: '',
        linkUrl: ROUTES.productsShop
      }
    ],

    packages: {
      banner: [],
      bannerMobile: [],
      modalBanners: [ModalPackagesBanner],
      modalTitle: 'Package Purchase in Progress',
      modalDescription:
        "You've previously started a package purchase, what would you like to do?",
      modalContinueBtnText: 'Resume Purchase',
      steps: [
        {
          title: 'Packages',
          icon: ListRadio,
          step: MembershipShopSteps.LIST
        },
        {
          title: 'Cart Details',
          icon: CalendarClock,
          step: MembershipShopSteps.PAYMENTS
        },
        {
          title: 'Purchase Details',
          icon: Check,
          step: MembershipShopSteps.TERMS
        }
      ],
      location: {
        title: 'Select Location',
        subtitle: 'Please select the location that you plan on visiting',
        paddings: { base: 0, md: 0, lg: 0 }
      },
      packages: {
        title: 'Lorem Ipsum',
        subtitle:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        paddings: { base: 0, md: 0, lg: 0 }
      },
      purchaseStep: {
        title: 'Purchase Details',
        subTitle: 'Select or securely add your credit card'
      },
      finalStep: {
        text: [
          'Thank you for purchasing an The Hair & Scalp Specialists package special. We are so happy you were able to take advantage of these limited-time savings. An order confirmation has been sent to your email address.',
          'To make things as easy as possible, we have automatically added your purchase to your client profile. When you visit on the day of your appointment, your purchase will be automatically applied at checkout.',
          'Thank you for choosing The Hair & Scalp Specialists. We can’t wait to help you look and feel like the most confident version of yourself.'
        ]
      }
    },
    giftCards: {
      modalBanners: [ModalOlbBanner],
      modalTitle: 'Gift Card Purchase in Progress',
      modalDescription:
        "You've already started a gift card purchase, what would you like to do?",
      modalContinueBtnText: 'Resume Purchase',
      steps: [
        {
          mobileName: 'style',
          name: 'gift card style',
          route: ROUTES.giftCardsShopSteps.selectStyles,
          icon: PainBrushSolid,
          access: AccessStep.All
        },
        {
          mobileName: 'amount',
          name: 'gift card amount',
          route: ROUTES.giftCardsShopSteps.selectAmount,
          icon: CircleDollar,
          access: AccessStep.All
        },
        {
          mobileName: "let's get started",
          name: "let's get started",
          route: ROUTES.giftCardsShopSteps.createAccount,
          icon: CircleExclamation,
          access: allowGuestShop ? AccessStep.Public : AccessStep.None
        },
        {
          mobileName: 'details',
          name: 'details & delivery',
          route: ROUTES.giftCardsShopSteps.details,
          icon: Envelope,
          access: AccessStep.All
        },
        {
          mobileName: 'cart',
          name: 'cart details',
          route: ROUTES.giftCardsShopSteps.cartDetails,
          icon: ShoppingBag,
          access: AccessStep.All
        },
        {
          mobileName: 'payment',
          name: 'payment details',
          route: ROUTES.giftCardsShopSteps.paymentDetails,
          icon: CreditCardFront,
          access: AccessStep.All
        }
      ],
      stylesStep: {
        title: 'Select Your E-Gift Card',
        description: 'Choose from the e-gift design options below',
        paddings: { base: 0, md: 0, lg: 0 }
      },
      selectAmount: {
        title: 'Select or Enter a Dollar Amount',
        paddings: { base: 0, md: 0, lg: 0 },
        giftCardsAmounts: [150, 250, 350, 550, 750, 1000, 1500, 1750]
      },
      createAccount: {
        title: 'How Would You Like to Checkout?',
        description:
          'Log in or create an account for a faster experience, or continue as a guest — no account needed.'
      },
      details: {
        title: 'Gift Card Details',
        description:
          'Please enter the recipient, the optional personalized message, and the delivery details below',
        paddings: { base: 0, md: '16px', lg: 0 },
        recipientFormContent: {
          title: 'Select or Enter Recipient’s Email'
        }
      },
      cartDetails: {
        title: 'Cart Details',
        paddings: { base: 0, md: 0, lg: 0 }
      },
      success: {
        title:
          'Your order has been successfully received. A copy of your order has been sent to ',
        subtitle: 'If you find any errors, please contact us immediately at ',
        logo: Logo,
        giftCard: {
          heading: 'Thank You!',
          orderCompleteText: 'Your Order Is Complete',
          downloadText:
            "Your gift card has been emailed to you.\nClick below if you'd like to download it now.",
          downloadButtonText: 'DOWNLOAD NOW',
          guestAccountTitle: 'Turn your guest checkout into an account',
          guestAccountDescription:
            'With your details already entered, just pick a password to unlock order tracking and faster checkout',
          createAccountButtonText: 'CREATE ACCOUNT',
          myGiftCardsButtonText: 'My Gift Cards',
          myDashboardButtonText: 'My Dashboard'
        }
      }
    },
    memberships: {
      steps: [
        {
          title: 'Membership',
          icon: ListRadio,
          step: MembershipShopSteps.LIST
        },
        {
          title: 'Payment Details',
          icon: CalendarClock,
          step: MembershipShopSteps.PAYMENTS
        },
        { title: 'Final Step', icon: Check, step: MembershipShopSteps.TERMS }
      ],
      location: {
        title: 'Select Location',
        subtitle: 'Please select the location that you plan on visiting',
        paddings: { base: 0, md: 0, lg: 0 }
      },
      list: {
        title: 'Select Your Membership',
        subtitle: 'Select our membership below to get started!',
        paddings: { base: 0, md: 0, lg: 0 }
      },
      paymentsDetails: {
        title: 'Purchase Details',
        subtitle: 'Select or securely add your credit card',
        description: ''
      },
      finalStep: {
        text: [
          'Thank you for purchasing a The Hair & Scalp Specialists membership. We are so happy you were able to take advantage of these limited-time savings. An order confirmation has been sent to your email address.',
          'Thank you for choosing The Hair & Scalp Specialists. We can’t wait to help you look and feel like the most confident version of yourself.'
        ]
      },
      modal: {
        modalBanners: [ModalOlbBanner],
        modalTitle: 'Membership Purchase in Progress',
        modalDescription:
          "You've previously started a membership purchase, what would you like to do?",
        modalContinueBtnText: 'Continue'
      }
    },
    cart: {
      modalBanners: [ModalOlbBanner],
      errorModal: {
        title: 'Something went wrong...',
        description: 'Contact us for more information',
        phone: '720-734-1126'
      }
    },
    guestCheckoutModal: {
      title: 'Checkout Options',
      mainText: 'Continue as guest or login to proceed',
      warningText:
        'Warning! All the Packages will be removed from the cart if you proceed as guest.',
      banners: [login_banner_desktop_1]
    }
  },

  booking: {
    defaultProvider,
    DefaultProviderAvatar,
    isCancellationPolicyRequired: false,
    modalBanners: [ModalOlbBanner],
    modalTitle: 'Booking in Progress',
    modalDescription:
      'You are already booking an appointment, what would you like to do?',
    modalContinueBtnText: 'Continue Booking',
    steps: [
      { title: 'Service', icon: ListRadio, step: BookingSteps.SERVICE },
      { title: 'Day & Time', icon: CalendarClock, step: BookingSteps.TIME },
      { title: 'Review & Reserve', icon: Check, step: BookingSteps.REVIEW }
    ],
    location: {
      title: 'Welcome to the Hair & Scalp Specialists',
      description: 'Please select the location you prefer for your appointment',
      paddings: { base: 0, md: 0, lg: 0 },
      banner: null,
      bannerMobile: null
    },
    service: {
      selectService: {
        selectServiceStep: {
          title: 'Select Service',
          description:
            'Please select a tab below and pick the services for your appointment',
          paddings: { base: 0, md: 0, lg: 0 },
          helperText:
            'Member pricing and other savings shown after date and time have been selected'
        },
        enhanceServiceStep: {
          title: 'Enhance Your Experience',
          description:
            'Based on the services you’ve selected, here are some popular add-on services',
          paddings: { base: 0, md: 0, lg: 0 }
        },
        selectProviderStep: {
          title: 'Select Preferred Provider',
          description: '',
          paddings: { base: 0, md: 0, lg: 0 }
        }
      }
    },
    time: {
      title: 'Search For Appointment Times',
      description:
        'Please click Show First Available to see upcoming appointment dates and times, or select the desired \n' +
        'appointment date below to see available times',
      paddings: { base: 0, md: 0, lg: 0 },
      subtitle: 'If you need assistance, please call us at ',
      advancedSearchHelperText:
        'Set your preferences then click the search button to see the matching availability'
    },
    review: {
      title: 'Almost Done',
      paddings: { base: 0, md: 0, lg: 0 },
      descriptionStart: 'Please review the appointment details below',
      descriptionMiddle:
        'If correct, check the box acknowledging our booking terms and conditions',
      descriptionEnd:
        'If you have any comments about this booking, please enter them in the designated area. Then, simply click the BOOK NOW button to complete your booking.',
      descriptionMoveEnd:
        'If you have any comments about this modification, please enter them in the designated area. Then, simply click the MOVE NOW button to complete your move.',
      rulesTitle:
        'By checking the box, you acknowledge and understand the following:',
      commentsBlockTitle:
        'If you have any comments for our staff, please provide them below:',
      infoBox: {
        title: 'Deposit Required to Complete Booking',
        subTitle:
          'is required to hold this reservation. Please provide the payment information below.',
        description:
          'This appointment will be reserved especially for you. We kindly request a 48-hour cancellation notice.',
        boldDescription:
          'If the reservation is missed or canceled with less than 24 hours notice, your deposit will be forfeited.'
      }
    },
    recommendedStep: {
      title: 'Recommended Products',
      description:
        "Based on the services you've booked, here are some products you may like",
      paddings: {}
    },
    success: {
      title: 'Booking Complete!',
      titleMove: 'Modification Complete!',
      description:
        'Your appointment is all set. Shortly, we will send you an email with the details of your reservation.'
    }
  },

  payment: {
    title: 'Sorry',
    description:
      'If you feel this was in error, please click the Try Again button below. Otherwise, you can use a different card.'
  }
};

export default hairscalp;
